import { Map, List } from 'immutable'
import actions from './actions'
import { PAGE_SIZE } from '../../../constants/customers'

const {
    CUSTOMER_ORDER_PAYMENT_DETAILS_FETCH,
    CUSTOMER_ORDER_PAYMENT_DETAILS_FETCH_SUCCESS,
    CUSTOMER_ORDER_PAYMENT_DETAILS_SET_PAGINATION,
} = actions

const initState = new Map({
    items: new List(),
    loading: false,
    pagination: new Map({
        current: null,
        pageSize: PAGE_SIZE,
        total: null
    })
})

export default function customerOrderPaymentDetailsReducer (state = initState, action) {
    const result = action.result

    switch (action.type) {
        case CUSTOMER_ORDER_PAYMENT_DETAILS_FETCH:
            return state.merge({ loading: true })
        case CUSTOMER_ORDER_PAYMENT_DETAILS_FETCH_SUCCESS:
            return state.merge({
                loading: false,
                items: new List(result)
            })
        case CUSTOMER_ORDER_PAYMENT_DETAILS_SET_PAGINATION:
            return state.mergeDeep({
                pagination: new Map(action.pagination)
            })
        default:
            return state
    }
}
